import React, {Component} from 'react';
import styled from 'styled-components';

const StyledInput = styled.input`
  border: 1px solid ${p => !p.wrong ? p.theme.cMicrocopyText : p.theme.cWrong};
  background: ${p => p.theme.cWhite};
  width: ${p => p.fixedWidth ? '220px' : '100%'};
  height: ${p => p.theme.sInput}px;
  padding-left: 16px;
  padding-right: 16px;
  ${p => p.center ? `text-align: center` : ``};
  outline: none !important;
  ${p => p.noBorder ? 'border: none' : ''}
  &:focus{
    border-color: ${p => p.theme.cTheme};
  }
  ::placeholder {
    color: ${p => p.theme.cBorderLight};
  }
`;

class Input extends Component {
    render() {
        return (
            <StyledInput {...this.props} className={this.props.className}/>
        );
    }
}

export default styled(Input)`
`;